import { CostSettings } from '../../../models/profit/profit.model';
import { useGet, useSend } from '../../useApi';

// GET / PUT /admin/cost-settings (new cost events only; history kept).
const useCostSettings = () => {
  const { data, loading, fetch, setData } = useGet<CostSettings>('Failed to load cost settings');
  const { loading: saving, send } = useSend<CostSettings>('Could not save');
  return {
    settings: data,
    loading,
    saving,
    fetchSettings: () => fetch('api/v1/admin/cost-settings'),
    save: (values: Record<string, any>, onDone?: () => void) =>
      send({ url: 'api/v1/admin/cost-settings', method: 'put', data: { values } }, (body) => {
        setData(body);
        onDone?.();
      }),
  };
};

export default useCostSettings;
